export default "__VITE_ASSET__B3eIi7F4__"